import React, { useState, useEffect, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import Popup from '../../components/Popup';
import { usePopupVideoAutoClose } from "../../hooks/usePopupVideoAutoClose";

function Module2() {

  // Page nav control

  const { canContinue, setCanContinue } = usePageControl();

  useEffect(() => {
    setCanContinue(true);
  }, [setCanContinue]);
  
  // Popup
  const [showPopup, setShowPopup] = useState(false);

  // - Time-based popup after page load
  const showAfterSeconds = 2; // Seconds

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, showAfterSeconds * 1000);

    return () => clearTimeout(timer);
  }, []);

  // - Manual popup trigger using class
  useEffect(() => {
    const triggers = document.querySelectorAll('.popup-trigger');
    triggers.forEach(trigger =>
      trigger.addEventListener('click', () => setShowPopup(true))
    );

    return () => {
      triggers.forEach(trigger =>
        trigger.removeEventListener('click', () => setShowPopup(true))
      );
    };
  }, []);

  
  // Popup Video Auto Close
  const {
    videoRef,
    handlePlay,
    handlePopupVideoEnded,
    cancelPopupAutoClose
  } = usePopupVideoAutoClose({ showPopup, setShowPopup });


  // Timer + start timer on page load
  const { startTimer, timeRemaining, formatTime, isRunning } = useTimer();

    useEffect(() => {
    startTimer(); // Delays starting the timer by X seconds. startTimer() or startTimer(0) would start straight away.
  }, [startTimer]);

   // Determine additional classes dynamically
  let additionalClasses = '';
  if (isRunning) {
    additionalClasses += ' timer-running';
  }
  if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
    additionalClasses += ' timer-warning';
  }
  if (timeRemaining < 0) { // time exceeded
    additionalClasses += ' timer-exceeded';
  } 


  return (
    <div id="module-2" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="box-wrapper-email">

                    <div id="email-client">
                      <div id="email-client-header"><h1 id="email-client-header-title">Email</h1></div>
                      <div id="email-client-body">
                        <div id="email-client-sidebar"><h2 id="email-client-sidebar-title">Inbox</h2></div>
                        <div id="email-client-content">

                          <div className="email">
                            <div className="email-header">
                              From: les.gettam@met.police.uk
                              <div className="email-attachment popup-trigger">Video</div>                         
                            </div>
                            <div className="email-body">
                              <h2 className="email-subject">Subject: If you're reading this… you're in!</h2>
                              <p>Right, so you've got the laptop. First job is to get into the DCI's system. Although she didn't tell me her password over the phone, she said she has been meaning to change it after seeing it in a <strong>Cyber Falcon Magazine</strong> article last week...</p>

                              <p>On the off chance she hasn't got around to changing it yet, find that article and run through the list.</p>

                              <p>DS Les Gettam</p>
                            </div>
                          </div>

                      </div>
                    </div>

                    </div>
                  </div>

      <Popup
        className="popup-box-video"
        title="DS Les Gettam"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        footer={
        <>
          <button onClick={handlePlay} className={"btn" + " " + "btn-video" + " " + "btn-video-play"}><span className="visually-hidden">Play video</span></button>
          <button onClick={() => setShowPopup(false)} className={"btn" + " " + "btn-video" + " " + "btn-video-close"}><span className="visually-hidden">Close video</span></button>
        </>
        }
      >
      <video
        ref={videoRef}
        controls
        onPlay={cancelPopupAutoClose} // make sure an auto-close timer isn't running on play
        onEnded={() => handlePopupVideoEnded(3)} // auto-close after X seconds when video ends
        controlsList="nodownload nofullscreen noremoteplayback"
        disablePictureInPicture
      >
        <source src={`/videos/offline/video_01a_1.mp4`} type="video/mp4" />
        Your browser does not support the video tag.
        <track src={`/videos/offline/video_01a_1.vtt`} kind="subtitles" srcLang="en" label="English" default></track>
      </video>
      </Popup>

                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module2;
